import React, { useCallback, useState } from 'react';

import { LoadScript } from '@react-google-maps/api';

import { StyledTableCell, StyledTableRow } from './ProviderLocationsTableRowV2.styles';
import { ROW_ACTIONS, RowMenuV2 } from './RowMenuV2';

import SnackBar from '../../../components/common/Snackbar';
import DeleteLocation from '../../../components/ProviderLocations/DeleteLocation';
import EditLocation from '../../../components/ProviderLocations/EditLocation';

export const ProviderLocationsTableRowV2 = ({
  row,
  refreshLocations,
  providerName,
  userType,
  majorProvidersList,
  onRefreshTransactions,
}) => {
  const [isSnackBarOpen, setIsSnackBarOpen] = useState(false);
  const [isSnackBarOpenLocAlreadyExists, setIsSnackBarOpenLocAlreadyExists] = useState(false);
  const [rowAction, setRowAction] = useState(null);

  const onSuccessEditLocation = useCallback(() => {
    setIsSnackBarOpen(true);
    setTimeout(() => refreshLocations('isEditSuccess'), 1000);
  }, [refreshLocations]);

  const onSuccessEditLocationAlreadyExists = useCallback(
    () => setIsSnackBarOpenLocAlreadyExists(true),
    [],
  );

  const onCloseDeleteItemModal = useCallback(
    (val) => {
      setRowAction(null);

      if (val == 'deleted') refreshLocations('isDeleteSuccess');
    },
    [refreshLocations],
  );

  const onCloseEditLocation = useCallback(() => setRowAction(null), []);
  const onClickedEditFromView = useCallback(() => setRowAction(ROW_ACTIONS.Edit), []);

  return (
    <>
      <StyledTableRow>
        <StyledTableCell width="3%" style={{ textAlign: 'center' }}>
          {row.SERIAL_NO}
        </StyledTableCell>
        <StyledTableCell width="25%">{row.provider_name}</StyledTableCell>
        <StyledTableCell width="55%">{row.formatted_address}</StyledTableCell>
        <StyledTableCell width="15%">{row.provider_updated_date}</StyledTableCell>
        <StyledTableCell colSpan={2} width="2%">
          <RowMenuV2 selectedAction={rowAction} setSelectedAction={setRowAction} />
        </StyledTableCell>
      </StyledTableRow>
      {isSnackBarOpen && (
        <SnackBar
          title="Location successfully updated"
          delay={8000}
          onClose={() => setIsSnackBarOpen(false)}
        />
      )}
      {isSnackBarOpenLocAlreadyExists && (
        <SnackBar
          title="'The location you are trying to add already exists in the database. Please verify the details and add the provider location again.';"
          onClose={() => setIsSnackBarOpenLocAlreadyExists(false)}
          delay={8000}
          isError
          customClass="snackBarBlock"
        />
      )}
      {rowAction === ROW_ACTIONS.Delete && (
        <DeleteLocation
          item={row}
          isOpen={rowAction === ROW_ACTIONS.Delete}
          onClose={onCloseDeleteItemModal}
          onRefreshTransactions={onRefreshTransactions}
        />
      )}
      {(rowAction === ROW_ACTIONS.Edit || rowAction === ROW_ACTIONS.View) && (
        <LoadScript
          googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY_RESTRICT}
          libraries={['places']}
          loadingElement={<div style={{ height: `1%` }} />}
        >
          <EditLocation
            item={row}
            providerName={providerName}
            userType={userType}
            majorProvidersList={majorProvidersList}
            isOpen={rowAction === 'edit' || rowAction === 'view'}
            onClose={onCloseEditLocation}
            isEditOption={rowAction === 'edit'}
            isOnlyViewOption={rowAction === 'view'}
            onSuccessEditLocation={onSuccessEditLocation}
            onSuccessEditLocationAlreadyExists={onSuccessEditLocationAlreadyExists}
            onClickedEditFromView={onClickedEditFromView}
            onRefreshTransactions={onRefreshTransactions}
          />
        </LoadScript>
      )}
    </>
  );
};
